<div class="support min-vh-100 d-flex flex-column">
  <div class="support-header">
    <div class="container">
      <div class="header d-flex justify-content-between py-4">
        <div class="header-logo d-flex align-items-center">
          <img src="/assets/icons/Logo.svg" alt="">
          <span class="ms-3 fs-4 fw-bold text-primblack">
            Improvemath
          </span>
        </div>
        <a routerLink="/" class="btn btn-outline app-btn-yellow">
          Home page
        </a>
      </div>
    </div>
  </div>
  <div class="support-body flex-grow-1 d-flex align-items-center">
    <div class="container h-100">
      <div class="row justify-content-center">
        <div class="d-none d-md-flex col-6 align-items-center">
          <img src="/assets/support_illustration.png" alt="" class="w-100">
        </div>
        <div class="col-12 col-md-6 py-7">
          <div class="row align-items-center justify-content-center" *ngIf="!messageSent">
            <div class="col-12 col-lg-11" [formGroup]="supportForm">
              <h2 class="support-title text-center mb-10">
                Contact customer support
              </h2>
              <div class="mb-5">
                <input type="text" class="form-control p-5" id="support-name"
                       placeholder="Your name"
                       formControlName="nameControl">
                <small
                  class="text-danger"
                  *ngIf="supportForm.controls.nameControl.errors?.minlength"
                >
                  Minimum 5 symbols
                </small>
              </div>
              <div class="mb-5">
                <input
                  type="email"
                  class="form-control p-5"
                  id="support-email"
                  placeholder="Email"
                  (input)="toLowerCase()"
                  formControlName="emailControl">
                <small
                  class="text-danger"
                  *ngIf="supportForm.controls.emailControl.errors?.pattern"
                >
                  Email address is invalid
                </small>
              </div>
              <div class="mb-5">
                <select class="form-select"
                        formControlName="reasonControl">
                  <option selected disabled value="">Reason for your inquiry</option>
                  <option value="Issue with expert/solution">Issue with expert/solution</option>
                  <option value="Cancel Subscription">Cancel Subscription</option>
                  <option value="Technical issues">Technical issues</option>
                  <option value="General questions">General questions</option>
                  <option value="Other questions">Other questions</option>
                </select>
              </div>
              <div class="mb-7 mb-md-10">
                <textarea
                  formControlName="textControl"
                  (input)="auto_grow($event)"
                  class="form-control support-reason px-4 py-5"
                  placeholder="Your message"
                ></textarea>
                <small
                  class="text-danger"
                  *ngIf="supportForm.controls.textControl.errors?.minlength"
                >
                  Minimum 15 symbols
                </small>
              </div>
              <button
                class="btn btn-outline app-btn-black w-100"
                [class.disabled]="!supportForm.valid"
                type="button"
                (click)="sendSupport()">
                Send
              </button>
            </div>
          </div>
          <div class="row align-items-center justify-content-center" *ngIf="messageSent">
            <div class="col-12 col-md-9">
              <div class="d-flex justify-content-center mb-10">
                <img src="/assets/icons/ok.svg" alt="">
              </div>
              <h2 class="text-center mb-5">
                Thanks for reaching
                out&nbsp;to&nbsp;us!
              </h2>
              <p class="text-center mb-10">
                Our team will contact you at:
                <br>
                <span class="text-primblack">
                  {{supportForm.value.emailControl}}
                </span>
              </p>
              <a routerLink="/" class="btn app-btn-black w-100">
                Home page
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
